var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33301 0C1.22844 0 0.333008 0.895431 0.333008 2L0.333008 16L4.99967 11.3333L9.66634 16V2C9.66634 0.895431 8.77091 0 7.66634 0L2.33301 0ZM6.0635 5.80102V7.31669C6.0635 8.14051 5.1181 8.60599 4.46515 8.10365C4.22085 7.91569 4.07769 7.62493 4.07769 7.31669V5.81794C4.07769 5.57707 3.99075 5.34429 3.83285 5.1624L3.10349 4.32221C2.54149 3.67481 3.00134 2.66667 3.85865 2.66667H6.22466C7.06796 2.66667 7.53261 3.64632 6.99906 4.29937L6.28911 5.16832C6.1432 5.3469 6.0635 5.57041 6.0635 5.80102Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkBlack);
export default __webpack_public_path__ + "static/media/BookmarkBlack.3b8d7c8fecac26190353256db86908eb.svg";
export { ForwardRef as ReactComponent };